import makeTheme from './makeTheme.js';
var MainTheme = makeTheme({
  themeName: 'default',
  themeOptions: {}
});
export { MainTheme as default };